<template>
  <!-- 对话框 -->
  <el-drawer
    title="线下推广添加页面"
    :visible.sync="show"
    :with-header="false"
    :before-close="closeDialog"
    size="60%"
    :wrapperClosable="false"
  >
    <!-- 基本信息表单 -->
    <div class="form-box">
      <template>
        <el-form ref="form" :model="submit_data" autosize>
          <el-form-item label="推广标题" label-width="120px">
            <el-input
              type="textarea"
              autosize
              v-model="submit_data.title"
              :placeholder="submit_rules.title.placeholder"
              style="width: 80%"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="推广人数" label-width="120px">
            <el-input
              v-model.number="submit_data.promotion_num"
              :placeholder="submit_rules.promotion_num.placeholder"
              style="width: 220px"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="报名开始时间" label-width="120px">
            <el-date-picker
              v-model="submit_data.join_start_stamp"
              type="datetime"
              :placeholder="submit_rules.join_start_stamp.placeholder"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="margin-right: 10px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="报名结束时间" label-width="120px">
            <el-date-picker
              v-model="submit_data.join_end_stamp"
              type="datetime"
              :placeholder="submit_rules.join_end_stamp.placeholder"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="margin-right: 10px"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="活动开始时间" label-width="120px">
            <el-date-picker
              v-model="submit_data.start_stamp"
              type="datetime"
              :placeholder="submit_rules.start_stamp.placeholder"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="margin-right: 10px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="活动结束时间" label-width="120px">
            <el-date-picker
              v-model="submit_data.end_stamp"
              type="datetime"
              :placeholder="submit_rules.end_stamp.placeholder"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="margin-right: 10px"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="奖励表现分" label-width="120px">
            <el-input
              v-model.number="submit_data.reward_monitor"
              :placeholder="submit_rules.reward_monitor.placeholder"
              style="width: 220px"
            >
            </el-input>
          </el-form-item>

          <el-form-item label="选择优享券" label-width="120px">
            <el-select
              v-model="submit_data.reward_priority"
              placeholder="请选择优享券"
              clearable

            >
              <el-option
                :label="item.name"
                :value="item.priority_mode_code"
                v-for="(item, index) in reward_priority"
                :key="index"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="奖励优享券" label-width="120px">
            <el-input
              v-model.number="submit_data.reward_priority_num"
              :placeholder="submit_rules.reward_priority_num.placeholder"
              style="width: 220px"
            >
            </el-input>
          </el-form-item>
          <!-- <el-form-item label="奖励余额" label-width="120px">
            <el-input
              v-model.number="submit_data.reward_amount"
              :placeholder="submit_rules.reward_amount.placeholder"
              style="width: 220px"
            >
            </el-input>
          </el-form-item> -->

          <el-form-item label="奖励发放:" label-width="120px">
            <el-radio-group v-model="submit_data.give_type">
              <el-radio label="1">次日</el-radio>
              <el-radio label="2">次月</el-radio>
            </el-radio-group>
            <el-tooltip
              class="item"
              effect="dark"
              content="实时：审核通过立即发放；次月：审核通过次月发放"
              placement="right"
            >
              <i class="el-icon-question"></i>
            </el-tooltip>
          </el-form-item>

          <el-form-item label="推广内容" label-width="120px">
            <el-input
              type="textarea"
              autosize
              style="width: 80%"
              v-model="submit_data.promotion_text"
              :placeholder="submit_rules.promotion_text.placeholder"
            >
            </el-input>
          </el-form-item>
        </el-form>

        <!-- 对话框底部按钮 -->
        <div style="display: flex; justify-content: center; margin-top: 20px">
          <submitBtn
            :data="submit_data"
            :rules="submit_rules"
            url="/Offlinepromotion/editPromotionTask"
            @onSubmitDig="onSubmitDig"
            :JSON_Boolean="false"
          >
            保存
          </submitBtn>

          <el-button @click="closeDialog">关闭</el-button>
        </div>
      </template>
    </div>
  </el-drawer>
</template>

<script>
var _this;

export default {
  props: {
    isShow: Boolean,
    data: {},
  },
  watch: {
    isShow(newData, oldData) {
      _this.show = true;
      console.log("编辑页面");
      _this.submit_data.task_code = _this.data.task_code;

      _this.priorityLists();
      _this.getPromotionTaskDetail();
    },
  },
  data() {
    return {
      show: false,
      reward_priority: [],

      // 表单数据
      submit_data: {
        title: "",
        promotion_num: "",
        join_start_stamp: "",
        join_end_stamp: "",
        start_stamp: "",
        end_stamp: "",
        reward_monitor: "",
        reward_priority: "",
        reward_priority_num: "",
        reward_amount: "",
        give_type: "",
        promotion_text: "",
  
      },
      search_data_reward: {
        page: 1,
        limit: 50,
  
      },

      submit_rules: {
        title: {
          placeholder: "请输入推广标题",
          rules: {
            required: true,
            message: "推广标题需小于等于100字",
            regulation: "elt_str",
            rulesData: 100,
          },
        },

        promotion_num: {
          placeholder: "推广人数",
          rules: {
            required: true,
            message: "推广人数为整数",
            regulation: "number",
            rulesData: 0,
          },
        },

        join_start_stamp: {
          placeholder: "报名开始时间",
          rules: {
            required: true,
            message: "报名开始时间",
            regulation: "gt_str",
            rulesData: "0",
          },
        },
        join_end_stamp: {
          placeholder: "报名结束时间",
          rules: {
            required: true,
            message: "报名结束时间",
            regulation: "gt_str",
            rulesData: "0",
          },
        },

        start_stamp: {
          placeholder: "请选择活动开始时间",
          rules: {
            required: true,
            message: "活动开始时间错误",
            regulation: "gt_str",
            rulesData: 5,
          },
        },
        end_stamp: {
          placeholder: "请选择活动结束时间",
          rules: {
            required: true,
            message: "结束时间错误",
            regulation: "gt_str",
            rulesData: 0,
          },
        },
        reward_monitor: {
          placeholder: "表现分",
          rules: {
            required: false,
            message: "表现分为整数",
            regulation: "number",
            rulesData: 0,
          },
        },
        reward_priority: {
          placeholder: "请选择优享券",
          rules: {
            required: false,
            message: "优享券错误",
            regulation: "gt_str",
            rulesData: 0,
          },
        },
        reward_priority_num: {
          placeholder: "请填写优享券数量",
          rules: {
            required: false,
            message: "优享券数量为整数",
            regulation: "number",
            rulesData: 0,
          },
        },
        reward_amount: {
          placeholder: "请输入余额",
          rules: {
            required: false,
            message: "余额错误",
            regulation: "gt_str",
            rulesData: 0,
          },
        },
        promotion_text: {
          placeholder: "请输入推广内容",
          rules: {
            required: true,
            message: "推广内容错误",
            regulation: "gt_str",
            rulesData: 0,
          },
        },
           give_type: {
          placeholder: "奖励发放选项",
          rules: {
            required: true,
            message: "奖励发放选项",
            regulation: "gt_str",
            rulesData: 0,
          },
        },
      },
    };
  },
  created() {
    _this = this;
  },
  methods: {
    getPromotionTaskDetail() {
      _this
        .$post("/Offlinepromotion/getPromotionTaskDetail", {

          task_code: _this.submit_data.task_code,
        })
        .then((res) => {
          _this.submit_data.title = res.data.title;
          _this.submit_data.promotion_num = res.data.promotion_num;
          _this.submit_data.join_start_stamp = res.data.join_start_stamp;
          _this.submit_data.join_end_stamp = res.data.join_end_stamp;
          _this.submit_data.start_stamp = res.data.start_stamp;
          _this.submit_data.end_stamp = res.data.end_stamp;
          _this.submit_data.reward_monitor = res.data.reward_monitor;
          _this.submit_data.reward_priority = res.data.reward_priority;
          _this.submit_data.reward_priority_num = res.data.reward_priority_num;
          _this.submit_data.reward_amount = res.data.reward_amount;
          _this.submit_data.give_type = res.data.give_type;
          _this.submit_data.promotion_text = res.data.promotion_text;
        })
        .catch((err) => {});
    },
    // 获取优享券
    priorityLists() {
      _this
        .$post("/priority/priorityLists", _this.search_data_reward)
        .then((res) => {
          _this.reward_priority = res.data;

          if (
            _this.search_data_reward.page * _this.search_data_reward.limit <
            res.count
          ) {
            _this.search_data_reward.page += 1;
            _this.priorityLists();
          }
        })
        .catch((err) => {});
    },
    // 关闭方法
    closeDialog() {
      _this.submit_data = {
        task_code: "",
        title: "",
        promotion_num: "",
        join_start_stamp: "",
        join_end_stamp: "",
        start_stamp: "",
        end_stamp: "",
        reward_monitor: "",
        reward_priority: "",
        reward_priority_num: "",
        reward_amount: "",
        give_type: "",
        promotion_text: "",
  
      };
      _this.show = false;
    },
  

    // 提交
    onSubmitDig() {
      console.log(_this.submit_data, "提交数据");

      // 触发父组件自定义事件刷新表格
      _this.$emit("onSubmit");
      _this.closeDialog();
    },
  },
};
</script>

<style scoped>
.form-box {
  padding: 20px;
  box-sizing: border-box;
  margin-right: 0;
  width: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

.el-form-second {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.avatar-uploader {
  width: 100px;
  height: 100px;
}

.avatar-uploader img {
  display: block;
  width: 100%;
  height: 100%;
}

.verify_remarks {
  font-size: 14px;
  color: #606266;
}

.quill-editor {
  width: 80%;
}
</style>